import React from 'react';
import SwapPlayersButton from 'components/organisms/players-to-exchange/swap-players-button';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';
import TableElement from 'components/organisms/players-to-exchange/table-elements/table-element';

export default class BasePlayerBuilder {
    constructor(private sportConfig) {}

    getSwapButton(
        salaryCapExceeded: boolean,
        substitutablePlayer: PlayerInterface,
        player: PlayerInterface,
        lineup: LineupInterface,
    ): JSX.Element | undefined {
        return salaryCapExceeded ? undefined : (
            <SwapPlayersButton
                searchPlayer={substitutablePlayer}
                replacePlayer={player}
                lineup={lineup}
                sportConfig={this.sportConfig}
            />
        );
    }

    buildRow(elements: object): TableElement[] {
        let row: TableElement[] = [];
        Object.entries(elements).map(([style, columnName]) => row.push(new TableElement(style, columnName)));

        return row;
    }
}
